import React from 'react'

export default () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.02194 7.02194L4 9L9.0661 3.9339" stroke="#CB2233" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
